module.exports = __webpack_public_path__ + "img/pause-circled-white.fda80fba.svg";